// Sesiune 82: gate descarcare PDF pentru guest.
// Daca userul curent are rol != "guest" (distribuitor real cu cont), descarcam direct.
// Altfel, dispatch event 'pdf-lead-gate' care deschide modalul global (LeadCaptureGate).

const NON_GUEST_ROLES = new Set(['admin', 'distribuitor', 'operator', 'contab']);

function getCurrentUser() {
  try {
    const raw = localStorage.getItem('oferte_user');
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (_) {
    return null;
  }
}

function getAuthToken() {
  try {
    return localStorage.getItem('oferte_token') || sessionStorage.getItem('oferte_token') || '';
  } catch (_) {
    return '';
  }
}

function appendQuery(url, key, value) {
  if (!value) return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}${key}=${encodeURIComponent(value)}`;
}

/**
 * Deschide un PDF cu gate guest.
 * @param {string} url - URL PDF (poate avea deja ?lang=...)
 * @param {object} opts - { sursa: 'scanx'|'obloane'|'configurator', id: string, mode?: 'assign'|'open' }
 */
// Sesiune 248: impacheteaza un URL PDF de oferta intr-o pagina intermediara de incarcare
// (spinner + contor secunde) ca sa nu mai apara pagina alba la ofertele mari.
export function pdfLoaderUrl(url) {
  try {
    const origin = (typeof window !== 'undefined' && window.location) ? window.location.origin : '';
    return `${origin}/api/pdf-loader?src=${encodeURIComponent(url)}`;
  } catch (_) {
    return url;
  }
}

export function openPdfWithGuestGate(url, opts = {}) {
  const mode = opts.mode || 'assign';
  const user = getCurrentUser();
  const isNonGuest = !!(user && user.rol && NON_GUEST_ROLES.has(user.rol));
  if (isNonGuest) {
    const finalUrl = appendQuery(url, 'token', getAuthToken());
    const loaderUrl = pdfLoaderUrl(finalUrl);
    if (mode === 'open') window.open(loaderUrl, '_blank');
    else window.location.assign(loaderUrl);
    return;
  }
  window.dispatchEvent(new CustomEvent('pdf-lead-gate', {
    detail: { url, sursa: opts.sursa, id: opts.id, mode },
  }));
}
